const GET = async () => {
  return new Response(null, {
    status: 404
  });
};
export {
  GET
};
